import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const SetQuizStatus = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [quizid, setQuizid] = useState("");
  const [status, setStatus] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    setQuizid(localStorage.getItem("quizid"));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSuccess(false);

    if (status !== "start" && status !== "stop") {
      setErrMsg("Please select a valid status.");
      return;
    }

    try {
      const response = await axiosPrivate.post(
        "/manager/quizstatus",
        JSON.stringify({ quizid, status })
      );

      setSuccess(true);
      setStatus("");
    } catch (err) {
      console.error(err);
      setErrMsg(err?.response?.data?.message || err?.message);
    }
  };

  return (
    <div className="fade-in" style={{ maxWidth: "600px", margin: "0 auto", padding: "2rem 1rem" }}>
      {/* Back Button */}
      <button
        className="btn-secondary"
        style={{ marginBottom: "1.5rem", padding: "0.5rem 1rem", fontSize: "0.875rem" }}
        onClick={() => navigate("/manager/quizdetails")}
      >
        ← Back to Quiz Details
      </button>

      {/* Header */}
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Set Quiz Status
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          Control the active state of your assessment
        </p>
      </div>

      {/* Messages */}
      {errMsg && <p className="errmsg">{errMsg}</p>}
      {success && (
        <div className="successmsg" style={{ textAlign: "center" }}>
          <p style={{ marginBottom: "1rem" }}>✓ Quiz status updated successfully!</p>
          <button
            className="btn-primary"
            onClick={() => navigate("/manager/quizdetails")}
            style={{ marginTop: "0.5rem" }}
          >
            Back to Quiz Details
          </button>
        </div>
      )}

      {/* Form Card */}
      {!success && (
        <div className="card" style={{ padding: "2.5rem" }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="status">Quiz Status</label>
              <select
                id="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="w-full"
                required
                style={{
                  appearance: "none",
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23CBD5E1' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 1rem center",
                  paddingRight: "3rem"
                }}
              >
                <option value="">Select status...</option>
                <option value="start">🟢 Start (Active)</option>
                <option value="stop">🔴 Stop (Inactive)</option>
              </select>
              <p className="instructions">
                'Start' allows participants to take the quiz. 'Stop' prevents new attempts.
              </p>
            </div>

            <div style={{ marginTop: "2rem", display: "flex", gap: "1rem" }}>
              <button type="submit" className="btn-primary" style={{ flex: 1 }}>
                Update Status
              </button>
              <button
                type="button"
                className="btn-secondary"
                onClick={() => navigate("/manager/quizdetails")}
                style={{ flex: 1 }}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default SetQuizStatus;
